module.exports = __webpack_public_path__ + "assets/images/project/pasir-ris-town/02.jpg?v=add69e3f";